module.exports = __webpack_public_path__ + "media/images/iconSearch__accent-7ecd18515cade78bae72ac3347d236de.png";